import type { Student } from "../types/student";

type SchoolLike = {
  schoolName?: string;
  schoolState?: string;
  schoolYear?: string;
};

function normalizeSchoolInfo(user?: Partial<Student> | null) {
  if (user?.school && typeof user.school === "object") {
    const school = user.school as SchoolLike;
    return {
      schoolName: school.schoolName || "",
      schoolState: school.schoolState || "",
      schoolYear: school.schoolYear || "",
    };
  }

  return {
    schoolName: typeof user?.school === "string" ? user.school : "",
    schoolState: user?.state || "",
    schoolYear: user?.spmYear ? String(user.spmYear) : "",
  };
}

function getUserResultDetails(user?: Partial<Student> | null) {
  return user?.resultDetails || user?.spmGrades || [];
}

export function computeProfileCompletion(
  user?: Partial<Student> | null,
): number {
  const currentUser = user || {};
  const school = normalizeSchoolInfo(currentUser);
  const resultDetails = getUserResultDetails(currentUser);

  const personal: [boolean, number][] = [
    [!!currentUser.name?.trim(), 5],
    [!!currentUser.email?.trim(), 5],
    [!!currentUser.phoneNumber?.trim(), 5],
    [!!currentUser.ic?.trim(), 5],
    [!!currentUser.dob?.trim(), 5],
    [!!currentUser.gender?.trim(), 5],
    [!!currentUser.state?.trim(), 5],
    [!!currentUser.countryCode?.trim(), 5],
  ];

  const academic: [boolean, number][] = [
    [!!school.schoolName.trim(), 10],
    [!!school.schoolYear.trim(), 10],
    [resultDetails.length > 0, 10],
  ];

  const preferences: [boolean, number][] = [
    [!!currentUser.pathway?.trim(), 10],
    [
      ((currentUser.courseFinderInterests || currentUser.interests)?.length ??
        0) > 0,
      10,
    ],
    [!!currentUser.budget?.trim(), 10],
  ];

  return [...personal, ...academic, ...preferences].reduce(
    (sum, [ok, points]) => sum + (ok ? points : 0),
    0,
  );
}
